import {
  API_STATUS,
  blankDetailedComplaint,
  BlankPagination,
  DEFAULT_OPTION,
  DEFAULT_OPTION_LOCATION_SET_TARGET,
  LIST_VIEW_ITEM,
  LOGIN_STATUS,
} from './Constant';
import {
  AssignGridInitialState,
  AttendanceInitialStateType,
  EmployeeDataInitialState,
  LocationFilterInitialState,
  LoginInitialState,
  MarketingActivityInitialState,
  ReimbursementInitialState,
  RemunerationInitialState,
} from './Types';

export const taskNameList = [
  {
    taskNameId: 1,
    taskSourceId: 1,
    sourceName: 'iAgri',
    taskName: 'Draw a Polygon',
  },
  {
    taskNameId: 2,
    taskSourceId: 2,
    taskName: 'CCE',
    sourceName: 'CCE',
  },
  {
    taskNameId: 3,
    taskName: 'CHM',
    taskSourceId: 2,
    sourceName: 'CCE',
  },
  {
    taskNameId: 4,
    taskSourceId: 2,
    taskName: 'IEC',
    sourceName: 'CCE',
  },
  {
    sourceName: 'Leads',
    taskName: 'Follow up lead',
    taskNameId: 7,
    taskSourceId: 3,
  },
  {
    sourceName: 'Leads',
    taskNameId: 8,
    taskSourceId: 3,
    taskName: 'View lead',
  },
  {
    sourceName: 'Leads',
    taskNameId: 5,
    taskName: 'Create lead',
    taskSourceId: 3,
  },
  {
    taskNameId: 6,
    taskName: 'Track Complaint',
    taskSourceId: 4,
    sourceName: 'Helpdesk',
  },
  {
    taskNameId: 9,
    taskName: 'Raise Complaint',
    taskSourceId: 4,
    sourceName: 'Helpdesk',
  },
];

export const loginMockData: LoginInitialState = {
  status: LOGIN_STATUS.AUTHENTICATED,
  user: {
    candidateId: 1,
    candidateUniqueId: '1100110001',
    employeeUniqueId: '1100110001',
    firstname: 'Test User',
    lastName: null,
    userActivationStatus: 3,
    userActivationStatusName: 'Active',
    accessToken: '',
    accessExpiryTime: '2024-06-25T17:14:04',
    resetToken: '2466bd23-6d40-4199-80ce-1a289b430ed5',
    resetExpiryTime: '2024-06-26T03:14:03',
    mobileNumber: 6666666661,
    emailId: 'test.user@kshema.co',
    loginType: 3,
    loginTypeName: 'INTERNAL',
    roleId: 4,
  },
  userDetails: {
    isemailverified: true,
    lastmodifiedon: '2024-06-14T11:06:55.179+00:00',
    firstname: 'CEO',
    useractivationstatus: 3,
    reportingmanagernumber: '',
    mobilenumber: 7777777771,
    gender: '',
    city: 1,
    employeeuniqueid: '1100110015',
    trainingstatus: true,
    teststatus: true,
    candidateuniqueid: '1100110015',
    reportingmanagername: '',
    isdeleted: false,
    locationname: '',
    zone: 1,
    ismobileverified: true,
    state: 1,
    candidateid: 16,
    reportingmanagerid: '',
    pincode: 500081,
    address: '',
    cityname: '',
    approvedby: null,
    photo:
      'https://sa4fieldassistdev.blob.core.windows.net/fa-datablobs/16_download.jpeg?sv=2022-11-02&ss=bfqt&srt=sco&sp=rwdlacupiytfx&se=2024-10-31T13:23:55Z&st=2024-05-03T05:23:55Z&spr=https&sig=eDq4KoQhpGr3h5t1OSPTIAmUxSFMhu87X7SjJ0tsJLg%3D',
    statusname: 'Active',
    emailid: 'fatest1@kshema.co',
    statename: '',
    createdon: '2024-05-28T06:30:11.789+00:00',
    zonename: '',
    lastname: '',
    approvedon: '',
    kycStatusName: 'APPROVED',
    maritalstatus: '',
    approvedbyname: null,
    dob: null,
    kycstatus: 3,
    location: 1,
    candidateId: '',
    employeeId: '',
    candidateUniqueId: '',
    employeeUniqueId: '',
    maritalStatus: '',
    mobileNumber: 0,
    isMobileVerified: false,
    emailId: '',
    isEmailVerified: false,
    userActivationStatus: 0,
    userActivationStatusName: '',
    kycStatus: 0,
    trainingStatus: false,
    testStatus: false,
    approvedBy: 0,
    approvedByName: '',
    approvedOn: '',
    isDeleted: false,
    createdOn: '',
    lastModifiedOn: '',
    reportingManagerId: 0,
    reportingManagerName: '',
    reportingManagerNumber: 0,
    reportingZones: [],
    reportingStates: [],
    roleId: 4,
    roleid: 4,
    roleName: '',
    assignedgrids: '',
    districtName: '',
    fullName: '',
    fullname: '',
    district: '',
    cityName: null,
    stateName: null,
    zoneName: null,
  },
  logout: null,
};
export const locationMockFilterData: LocationFilterInitialState = {
  zoneOptions: [
    { label: 'South Zone', value: 4 },
    { label: 'North Zone', value: 1 },
  ],
  statesData: {
    '1': [
      { label: 'Punjab', value: 3 },
      { label: 'Hariyana', value: 2 },
    ],
  },
  districtData: {
    '3': [
      {
        value: 27,
        label: 'Amritsar',
      },
      {
        value: 28,
        label: 'Bathinda',
      },
      {
        value: 29,
        label: 'Faridkot',
      },
    ],
  },
  cityOptions: {
    '27': [
      {
        label: 'Kaler Bala Pa',
        value: '395025',
      },
      {
        label: 'Mumbai - Greater Mumbai',
        value: 57362,
      },
      {
        label: 'Rudala',
        value: '394862',
      },
      {
        label: 'Dalleke',
        value: '392170',
      },
    ],
  },
  gridOptions: [],
};
export const attendanceMockData: AttendanceInitialStateType = {
  attendanceData: {
    pagination: {
      currentPage: 1,
      pageSize: 20,
      totalPages: 1,
      totalItems: 1,
      fromItem: 1,
      toItem: 1,
    },
    attendanceList: [],
  },
  leaveHistoryData: {
    pagination: {
      currentPage: 1,
      pageSize: 20,
      totalPages: 1,
      totalItems: 1,
      fromItem: 1,
      toItem: 1,
    },
    leaveList: [],
  },
  leaveTypes: [],
  statusDropOptions: [
    {
      value: 22,
      label: 'Pending',
    },
    {
      value: 23,
      label: 'Approved',
    },
    {
      value: 24,
      label: 'Rejected',
    },
  ],
  LeaveTypeDropOptions: [
    {
      value: 10,
      label: 'Sick',
    },
    {
      label: 'Casual',
      value: 11,
    },
    {
      value: 12,
      label: 'Earned',
    },
    {
      value: 13,
      label: 'Leave w/o Pay',
    },
  ],
  attendanceDetails: null,
  leaveDetails: {
    lastName: '',
    notes: [
      {
        notesId: 5764,
        createdOn: '2024-09-10 12:18:31',
        notesDescription: 'Leave Request raised by Testing four',
      },
    ],
    zohoReferenceId: null,
    city: 87628,
    endDate: '2024-09-16T00:00:00.000+00:00',
    mobileNumber: 6666666664,
    emailId: 'testmail4@kshema.co',
    createdOn: '2024-09-10T12:18:31.920+00:00',
    candidateUniqueId: '1100110004',
    leaveDays: 1,
    cityName: 'Serilingampally-Hyderabad',
    zone: 4,
    stateName: 'Telangana',
    reportingManagerRole: 'Zonal Head',
    leaveRequestId: 28,
    leaveTypeName: 'Casual',
    requestedSource: 1,
    state: 36,
    zoneName: 'South Zone',
    reasonForLeave: 'User',
    approver: '',
    pincode: 500081,
    comments: '',
    districtName: 'Ranga Reddy',
    roleId: 5,
    lastModifiedBy: null,
    photo:
      'https://sa4fieldassistdev.blob.core.windows.net/fa-datablobs/4?sv=2022-11-02&ss=bfqt&srt=sco&sp=rwdlacupiytfx&se=2024-10-31T13:23:55Z&st=2024-05-03T05:23:55Z&spr=https&sig=eDq4KoQhpGr3h5t1OSPTIAmUxSFMhu87X7SjJ0tsJLg%3D',
    reportingManagerName: 'South Zone Head',
    reportingManagerId: 9,
    zohoLeaveTypeId: '132709000000245060',
    approvedDate: null,
    firstName: 'Testing four',
    employeeUniqueId: '1100110004',
    district: 518,
    roleName: 'State Head',
    location: 87628,
    leaveTypeId: 11,
    leaveStatus: 'Pending',
    candidateId: 4,
    startDate: '2024-09-16T00:00:00.000+00:00',
    requestStatus: 22,
  },
  apiProgressStatus: '',
  approvedRejectedStatus: null,
};
export const assignGridMockData: AssignGridInitialState = {
  selectedCandidate: {
    result: {
      campaignDetails: [
        {
          employeecampaignmappingid: 31,
          campaignid: 4,
          descriptona: null,
          campaignname: 'Radio',
          descriptionb: null,
          campaignId: 0,
          campaignName: null,
          description_a: null,
          description_b: null,
          employeeCampaignMappingId: 0,
        },
        {
          campaignname: 'Streaming Service Ad',
          campaignid: 5,
          descriptona: null,
          descriptionb: null,
          employeecampaignmappingid: 32,
          campaignId: 0,
          campaignName: null,
          description_a: null,
          description_b: null,
          employeeCampaignMappingId: 0,
        },
        {
          campaignid: 6,
          descriptona: '',
          descriptionb: '',
          campaignname: 'Newspaper',
          employeecampaignmappingid: 33,
          campaignId: 0,
          campaignName: null,
          description_a: null,
          description_b: null,
          employeeCampaignMappingId: 0,
        },
      ],
      user: {
        assignedgrids: '4029, 4031, 4142, 4143, 4144, 4256, 4257',
        isemailverified: false,
        lastmodifiedon: '2024-06-25T06:45:19.884+00:00',
        firstname: 'Chandra',
        useractivationstatus: 3,
        reportingmanagernumber: 0,
        mobilenumber: 8798749798,
        gender: 'Female',
        city: 681,
        roleid: 7,
        employeeuniqueid: 'POSP-4-36-080361',
        trainingstatus: true,
        teststatus: true,
        candidateuniqueid: 'CD-4-36-2406-000243',
        reportingmanagername: '',
        isdeleted: false,
        locationname: 'Ragavpet',
        zone: 4,
        ismobileverified: true,
        approvedByName: 'CGO ',
        state: 36,
        candidateid: 243,
        reportingmanagerid: '',
        pincode: 505331,
        address: 'H.no 13-1-56/7',
        rolename: 'POSP',
        cityname: 'JAGTIAL',
        approvedby: 232,
        statusname: 'Active',
        photo:
          'https://sa4fieldassistdev.blob.core.windows.net/fa-datablobs/243_1000000220.jpg?sv=2022-11-02&ss=bfqt&srt=sco&sp=rwdlacupiytfx&se=2024-10-31T13:23:55Z&st=2024-05-03T05:23:55Z&spr=https&sig=eDq4KoQhpGr3h5t1OSPTIAmUxSFMhu87X7SjJ0tsJLg%3D',
        emailid: 'Chandra@gmail.com',
        statename: 'Telangana',
        createdon: '2024-06-25T06:40:37.282+00:00',
        zonename: 'South Zone',
        lastname: 'Sekhar',
        approvedon: '2024-06-25T06:41:03.405+00:00',
        kycStatusName: 'APPROVED',
        approvedbyname: 'CGO',
        maritalstatus: 'Unmarried',
        dob: '1986-06-25',
        kycstatus: 3,
        location: 78360,
        candidateId: '',
        employeeId: '',
        candidateUniqueId: '',
        employeeUniqueId: '',
        maritalStatus: '',
        mobileNumber: 0,
        isMobileVerified: false,
        emailId: '',
        isEmailVerified: false,
        roleId: 0,
        roleName: '',
        userActivationStatus: 0,
        userActivationStatusName: '',
        kycStatus: 0,
        trainingStatus: false,
        testStatus: false,
        approvedBy: 0,
        approvedOn: '',
        isDeleted: false,
        createdOn: '',
        lastModifiedOn: '',
        reportingManagerId: 0,
        reportingManagerName: '',
        reportingManagerNumber: 0,
        reportingZones: [],
        reportingStates: [],
        districtName: '',
        fullName: '',
        fullname: '',
        district: '',
        cityName: null,
        stateName: null,
        zoneName: null,
      },
      grids: [
        {
          employeegridmappingid: 14,
          revokedon: null,
          assignedon: '2024-06-26T17:07:11.946+00:00',
          assignedby: 247,
          revokedby: 0,
          revokedbyname: null,
          gridid: 4257,
          assignedbyname: 'CEO',
          candidateid: 243,
          approvedbyname: null,
        },
        {
          revokedon: null,
          employeegridmappingid: 7,
          assignedon: '2024-06-25T06:46:12.630+00:00',
          revokedby: 0,
          revokedbyname: null,
          assignedby: 232,
          gridid: 4144,
          assignedbyname: 'CGO',
          candidateid: 243,
          approvedbyname: null,
        },
        {
          revokedon: null,
          employeegridmappingid: 6,
          revokedby: 0,
          revokedbyname: null,
          assignedon: '2024-06-25T06:46:12.629+00:00',
          assignedby: 232,
          gridid: 4256,
          assignedbyname: 'CGO',
          candidateid: 243,
          approvedbyname: null,
        },
        {
          revokedon: null,
          gridid: 4029,
          revokedby: 0,
          revokedbyname: null,
          assignedby: 232,
          employeegridmappingid: 5,
          assignedon: '2024-06-25T06:46:12.628+00:00',
          assignedbyname: 'CGO',
          candidateid: 243,
          approvedbyname: null,
        },
        {
          revokedon: null,
          gridid: 4143,
          revokedby: 0,
          revokedbyname: null,
          employeegridmappingid: 4,
          assignedon: '2024-06-25T06:45:48.900+00:00',
          assignedby: 232,
          assignedbyname: 'CGO',
          candidateid: 243,
          approvedbyname: null,
        },
        {
          revokedon: null,
          gridid: 4142,
          assignedon: '2024-06-25T06:45:42.231+00:00',
          revokedby: 0,
          revokedbyname: null,
          assignedby: 232,
          assignedbyname: 'CGO',
          employeegridmappingid: 3,
          candidateid: 243,
          approvedbyname: null,
        },
        {
          revokedon: null,
          gridid: 4031,
          revokedby: 0,
          revokedbyname: null,
          assignedby: 232,
          assignedbyname: 'CGO',
          employeegridmappingid: 2,
          candidateid: 243,
          assignedon: '2024-06-25T06:45:34.545+00:00',
          approvedbyname: null,
        },
      ],
      notes: [],
      documents: [],
    },
    responseInformation: {
      responseCode: '',
      responseMessage: '',
    },
  },
  assignGridData: {
    responseInformation: {
      responseCode: '0',
      responseMessage:
        'Successfully obtained the list of employees, status is Active.',
    },
    result: [
      {
        pincode: 500047,
        assignedbyname: 'CGO',
        firstname: 'Rachana',
        assignedby: 232,
        reportingmanagernumber: 34,
        mobilenumber: 9809653666,
        city: 205,
        photo:
          'https://sa4fieldassistdev.blob.core.windows.net/fa-datablobs/235_download.jpeg?sv=2022-11-02&ss=bfqt&srt=sco&sp=rwdlacupiytfx&se=2024-10-31T13:23:55Z&st=2024-05-03T05:23:55Z&spr=https&sig=eDq4KoQhpGr3h5t1OSPTIAmUxSFMhu87X7SjJ0tsJLg%3D',
        employeeuniqueid: 'POSP-2-10-080361',
        assignedon: '2024-06-21T11:13:58.942+00:00',
        emailid: 'Rachana@hotmail.com',
        candidateuniqueid: 'CD-2-10-2406-000235',
        reportingmanagername: '',
        assignedgrids: '3716',
        lastname: 'Gadepalli',
        zone: 2,
        dob: '1949-06-21',
        location: 154524,
        state: 10,
        candidateid: 235,
        reportingmanagerid: 324,
      },
    ],
    pagination: {
      currentPage: 1,
      pageSize: 20,
      totalPages: 1,
      totalItems: 7,
      fromItem: 1,
      toItem: 2,
    },
  },
  gridReportingManager: {
    reportingManager: 'Test Kumar',
    reportingManagerRole: 'State Head',
    reportingManagerVillageName: 'Hyderabad',
    reportingManagerStateName: 'Telangana',
  },
};
export const reimbursementMockData: ReimbursementInitialState = {
  applyReimbursementData: [
    {
      taskId: 'TAK324324',
      taskName: 'Draw Polygon',
      sourceName: 'iAgri',
      sourceId: 10,
    },
    {
      taskId: 'TAK324324',
      taskName: 'ICE',
      sourceName: 'CCE',
      sourceId: 11,
    },
  ],
  applyReimbursementPagination: {
    currentPage: 1,
    pageSize: 20,
    totalPages: 1,
    totalItems: 2,
    fromItem: 1,
    toItem: 2,
  },
  approveReimbursementData: [
    {
      candidateUniqueId: 'EMP234324S',
      firstName: 'OM',
      lastName: 'Birla',
      zoneName: 'North',
      stateName: 'Hariyana',
      claimId: 'CM34THW',
      claimDate: '2024-07-19T14:08:28.173+00:00',
      claimType: 'Food',
      amount: 3000,
      status: 'Approval Pending',
    },
    {
      candidateUniqueId: 'EMP234324F',
      firstName: 'Srikant',
      lastName: 'Wagle',
      zoneName: 'West',
      stateName: 'Maharashtra',
      claimId: 'CM54THW',
      claimDate: '2024-07-16T14:08:28.173+00:00',
      claimType: 'Travel',
      amount: 5000,
      status: 'Approved',
    },
  ],
  approveReimbursementPagination: {
    currentPage: 1,
    pageSize: 20,
    totalPages: 1,
    totalItems: 2,
    fromItem: 1,
    toItem: 2,
  },
  reimbursementTypes: [
    { label: 'Travel', value: 1, pincode: 100561 },
    { label: 'Food', value: 2, pincode: 100562 },
    { label: 'Accommodation ', value: 3, pincode: 100563 },
    { label: 'Miscellaneous', value: 4, pincode: 100564 },
  ],
  taskNameList: taskNameList.map((task) => ({
    value: task.taskNameId,
    label: task.taskName,
  })),
  apiProgressStatus: '',
  statusDropOptions: [
    { value: 10, label: 'Approved' },
    { value: 12, label: 'Rejected' },
  ],
  approveReimbursementDetails: {
    claimId: '119',
    candidateId: 6,
    candidateUniqueId: '111116',
    employeeUniqueId: '111116',
    fullName: 'Telengana Head ',
    photo: null,
    mobileNumber: '7777777776',
    emailId: 'fatest6@kshema.co',
    zone: 4,
    zoneName: 'South Zone',
    state: 36,
    stateName: 'Telangana',
    district: 518,
    districtName: 'Ranga Reddy',
    city: 87628,
    cityName: 'Serilingampally-Hyderabad',
    pincode: 500107,
    roleId: '5',
    roleName: 'State Head',
    taskAssignmentId: 59,
    taskId: 'TAS-C-260924-0059',
    statusId: '26',
    statusName: 'Approval Pending',
    approvedBy: null,
    approvedByName: 'Telengana Head ',
    approvedOn: null,
    createdOn: '2024-10-01T18:27:54.593423',
    claimDetails: [
      {
        reimbursementRequestClaimId: 141,
        reimbursementRequestId: 119,
        reimbursementTypeId: 24,
        reimbursementTypeName: 'Travel',
        claimFromDate: '2024-10-01T18:26:33.395',
        claimToDate: null,
        locationA: 'Rodamestri Nagar',
        locationB: 'Jnttu',
        hotelName: null,
        totalDistance: '25.0',
        totalExpenses: '2000.00',
        zone: null,
        zoneName: null,
        state: null,
        stateName: null,
        district: null,
        districtName: null,
        city: null,
        cityName: null,
        pincode: null,
        reason: 'Test',
        comments: 'New',
        images: [
          {
            reimbursementClaimImageID: '157',
            filePath:
              'https://sa4fieldassistdev.blob.core.windows.net/fa-datablobs/141_2024100140800_CT24.jpeg?sv=2022-11-02&ss=bfqt&srt=sco&sp=rwdlacupiytfx&se=2024-10-31T13:23:55Z&st=2024-05-03T05:23:55Z&spr=https&sig=eDq4KoQhpGr3h5t1OSPTIAmUxSFMhu87X7SjJ0tsJLg%3D',
          },
        ],
      },
    ],
    notes: [
      {
        notesId: 1822,
        notesDescription: 'Claim Submitted',
        createdOn: '2024-10-01 18:27:54.604565',
      },
    ],
    claimType: 'Travel',
    address: 'Hyderabad',
    taskName: 'Track Complaint',
    totalClaimAmount: '2000.00',
  },
};
export const remunerationMockData: RemunerationInitialState = {
  remunerationList: {
    status: '',
    responseInformation: {
      responseCode: '',
      responseMessage: '',
    },
    result: [
      {
        candidateId: 278,
        candidateUniqueId: 'CD-4-36-2409-000277',
        candidateName: 'User - e ',
        employeeUniqueId: 'POSP-4-36-040146',
        photo: null,
        mobileNumber: 7396365589,
        emailId: 'user_e@testkshema.co',
        roleId: '7',
        roleNames: 'POSP',
        zoneId: 4,
        stateId: 36,
        districtId: 518,
        cityId: 87628,
        pincode: 500047,
        lastApprovedOn: null,
        leadsCreatedCount: 0,
        leadsClosedCount: 0,
        chmCount: 0,
        surveyCount: 0,
        iecCount: 0,
        cceCount: 0,
        complaintsRaisedCount: 0,
        complaintsClosedCount: 0,
        appRegistrationCount: 0,
        drawPolygonCount: 0,
        marketingActivityCount: 3,
      },
    ],
    pagination: {
      currentPage: 1,
      pageSize: 20,
      totalPages: 1,
      totalItems: 2,
      fromItem: 1,
      toItem: 2,
    },
  },
};
export const trackComplaintsMockData = {
  trackComplaintsData: {
    status: '',
    pagination: BlankPagination,
    result: [],
  },
  detailedComplaintData: {
    status: '',
    result: blankDetailedComplaint,
  },
  severityOptions: [DEFAULT_OPTION],
  statusOptions: [DEFAULT_OPTION],
  employeeList: [],
  employeeNameOptions: [
    { value: 101, label: 'Test User1' },
    { value: 102, label: 'Test User2' },
  ],
};
export const marketingActivityMockData: MarketingActivityInitialState = {
  yearOptions: [
    {
      financialYearId: '1',
      financialYearName: '2023-2024',
      calendarYear: '2023',
      isCurrentYear: false,
    },
    {
      financialYearId: '2',
      financialYearName: '2024-2025',
      calendarYear: '2024',
      isCurrentYear: true,
    },
  ],
  seasonOptions: [
    {
      value: 1,
      label: 'Rabi',
    },
    {
      value: 2,
      label: 'Kharif',
    },
  ],
  employeeList: [
    {
      employeeId: 12345,
      candidateUniqueId: 'CAND123456',
      employeeUniqueId: 'EMP123456',
      employeeName: 'John Doe',
      mobileNumber: 9876543210,
      cityId: 'CITY123',
      districtId: 'DIST123',
      zoneId: 'ZONE123',
      stateId: 'STATE123',
      role: 'ROLE123',
      roleName: 'Software Engineer',
      email: 'john.doe@example.com',
      pincode: '123456',
    },
    {
      employeeId: 67890,
      candidateUniqueId: 'CAND654321',
      employeeUniqueId: 'EMP654321',
      employeeName: 'Jane Smith',
      mobileNumber: 1234567890,
      cityId: 'CITY456',
      districtId: 'DIST456',
      zoneId: 'ZONE456',
      stateId: 'STATE456',
      role: 'ROLE456',
      roleName: 'Project Manager',
      email: 'jane.smith@example.com',
      pincode: '654321',
    },
  ],
  marketingTypes: [
    { value: 16, label: 'Mobile Van Campaign' },
    { value: 17, label: 'Wall Papers' },
  ],
  marketingActivityList: {
    pagination: BlankPagination,
    result: [
      {
        marketingActivityId: 77,
        activityUniqueId: 'MA-300824-4-36-00077',
        activityStartDate: '2024-11-28T17:15:00',
        activityEndDate: '2024-11-28T17:15:00',
        financialYear: 15,
        financialYearName: '2024-2025',
        season: 15,
        seasonName: '2024-2025',
        activityTypeId: 19,
        activityTypeName: 'Pamphlet',
        zone: 1,
        state: 3,
        district: 27,
        city: 395025,
        pincode: 505331,
        activityStatusId: 33,
        activityStatusName: 'Completed',
        countWalkin: 39,
        countAppRegistration: 2,
        countLead: 1,
        countComplaint: 0,
        approvedBy: 6,
        approvedOn: '2024-08-31T14:58:22.510713',
        zoneName: '',
        stateName: '',
        districtName: '',
        cityName: '',
      },
      {
        marketingActivityId: 77,
        activityUniqueId: 'MA-300824-4-36-00078',
        activityStartDate: '2024-11-28T18:15:00',
        activityEndDate: '2024-11-28T18:15:00',
        financialYear: 15,
        financialYearName: '2023-2024',
        season: 15,
        seasonName: 'Rabi',
        activityTypeId: 19,
        activityTypeName: 'Walpaper',
        zone: 2,
        state: 4,
        district: 29,
        city: 395027,
        pincode: 505337,
        activityStatusId: 32,
        activityStatusName: 'Review Pending',
        countWalkin: 39,
        countAppRegistration: 2,
        countLead: 1,
        countComplaint: 0,
        approvedBy: 6,
        approvedOn: '2024-08-31T14:58:22.510713',
        zoneName: '',
        stateName: '',
        districtName: '',
        cityName: '',
      },
    ],
    status: 'succeeded',
  },
  statusOptions: [DEFAULT_OPTION_LOCATION_SET_TARGET],
};
export const leadMockData = {
  leadListData: {
    result: [
      {
        assignedToId: null,
        assignedToRoleID: null,
        leadTypeId: 1,
        assignedToRoleName: null,
        leadReceivedOn: '2024-07-22T05:45:00.000+00:00',
        leadTypeName: 'Field Assist',
        assignedToName: 'Test User',
        assignedToCantidateUniqueId: 'ABDC3345',
        district: 188,
        leadId: 'LID-O-220724-0267',
        assignedToNumber: null,
        city: 604707,
        leadName: 'bhanu',
        state: 10,
        pincode: 854333,
        leadStatus: 16,
        leadGenerationId: 267,
        leadStatusName: 'Follow up',
        createdOn: '2024-07-22T05:46:00.306+00:00',
        leadNumber: '9573940055',
        zone: 2,
        leadLinkId: null,
        leadClosedOn: null,
        assignedToEmployeeUniqueId: null,
      },
    ],
    pagination: BlankPagination,
  },
  leadTypeOptions: [{ value: 1, label: 'Field Assist' }],
  statusDropOptions: [
    {
      value: 14,
      label: 'New',
    },
    {
      value: 16,
      label: 'Follow up',
    },
    {
      value: 17,
      label: 'Unqualified',
    },
    {
      value: 18,
      label: 'Close',
    },
  ],
  apiProgressStatus: '',
};
export const taskMockData = {
  apiProgressStatus: API_STATUS.SUCCEEDED,
  selectedTask: {
    city: '',
    assignedToName: 'Test Name',
    assignedToCantidateUniqueId: '1100110009',
    createdOn: '2024-06-27T01:00:00.795+00:00',
    assignedToNumber: '6666666669',
    state: '',
    taskStatus: 10,
    assignedToEmployeeUniqueId: '1100110009',
    pincode: 123456,
    taskStatusName: 'Assigned',
    assignedToRoleName: 'State Head',
    customerName: '',
    completedOn: '',
    taskName: 'CHM',
    sourceName: 'CCE',
    taskAssignmentId: 399,
    taskId: 'TAS-C-270624-0399',
    assignedToRoleID: 0,
    assignedToId: 0,
    source: 0,
    startedOn: '',
    customerNumber: 0,
    lastModifiedOn: '',
    customerID: 0,
    location: '',
  },
  taskListData: {
    result: [
      {
        assignedToId: null,
        assignedToRoleID: null,
        assignedToCantidateUniqueId: null,
        district: 'PATNA',
        taskSourceId: 2,
        createdOn: '2024-06-28 13:47:37',
        assignedToNumber: null,
        taskNameId: 2,
        taskStatus: 12,
        taskStatusName: 'New',
        customerId: null,
        state: 'Bihar',
        taskName: 'Draw a Polygon',
        sourceName: 'iAgri',
        assignedToEmployeeUniqueId: null,
        taskLinkId: 'CCE1719562657142',
        assignedToRoleName: null,
        assignedToName: ' ',
        taskAssignmentId: 405,
        location: 143250,
        customerNumber: null,
        pincode: 800001,
        completedOn: '2024-06-28 13:47:00',
        customerName: null,
        policyId: '',
        city: 'PATNA',
        taskId: 'TAS-O-280624-0405',
      },
      {
        assignedToId: null,
        assignedToRoleID: null,
        assignedToCantidateUniqueId: null,
        district: 'PATNA',
        taskSourceId: 2,
        assignedToNumber: null,
        taskNameId: 2,
        taskStatus: 12,
        taskStatusName: 'Closed',
        customerId: null,
        state: 'Bihar',
        taskName: 'CCE',
        sourceName: 'CCE',
        assignedToEmployeeUniqueId: null,
        assignedToRoleName: null,
        createdOn: '2024-06-28 13:38:50',
        assignedToName: ' ',
        taskAssignmentId: 404,
        location: 143250,
        customerNumber: null,
        pincode: 800001,
        customerName: null,
        policyId: '',
        city: 'PATNA',
        completedOn: '2024-06-28 13:38:00',
        taskLinkId: 'CCE1719562130289',
        taskId: 'TAS-O-280624-0404',
      },
    ],
    pagination: {
      currentPage: 1,
      pageSize: 20,
      totalPages: 2,
      totalItems: 47,
      fromItem: 1,
      toItem: 20,
    },
  },
  taskNameList: [
    {
      taskNameId: 1,
      taskSourceId: 1,
      sourceName: 'iAgri',
      taskName: 'Draw a Polygon',
    },
    {
      taskNameId: 2,
      taskSourceId: 2,
      taskName: 'CCE',
      sourceName: 'CCE',
    },
    {
      taskNameId: 3,
      taskName: 'CHM',
      taskSourceId: 2,
      sourceName: 'CCE',
    },
    {
      taskNameId: 4,
      taskSourceId: 2,
      taskName: 'IEC',
      sourceName: 'CCE',
    },
    {
      sourceName: 'Leads',
      taskName: 'Follow up lead',
      taskNameId: 7,
      taskSourceId: 3,
    },
    {
      sourceName: 'Leads',
      taskNameId: 8,
      taskSourceId: 3,
      taskName: 'View lead',
    },
    {
      sourceName: 'Leads',
      taskNameId: 5,
      taskName: 'Create lead',
      taskSourceId: 3,
    },
    {
      taskNameId: 6,
      taskName: 'Track Complaint',
      taskSourceId: 4,
      sourceName: 'Helpdesk',
    },
    {
      taskNameId: 9,
      taskName: 'Raise Complaint',
      taskSourceId: 4,
      sourceName: 'Helpdesk',
    },
  ],
  employeeList: [
    {
      roleName: 'State Head',
      roleId: 5,
      candidateId: 9,
      mobileNumber: 6666666668,
      employeeName: 'Test user',
      employeeUniqueId: '1100110009',
    },
    {
      candidateId: 204,
      mobileNumber: 9877745078,
      roleName: 'POSP',
      roleId: 7,
      employeeName: 'Apro Empo',
      employeeUniqueId: 'POSP-4-36-120023',
    },
  ],
  taskStatusList: [
    {
      statusId: 9,
      statusName: 'New',
    },
    {
      statusId: 10,
      statusName: 'Assigned',
    },
    {
      statusId: 11,
      statusName: 'Inprogress',
    },
    {
      statusId: 12,
      statusName: 'Closed',
    },
    {
      statusId: 13,
      statusName: 'Completed',
    },
  ],
  employeeNameOptions: [
    { value: 101, label: 'Test User1' },
    { value: 102, label: 'Test User2' },
  ],
};
export const setTargetMockData = {
  targetListData: {
    result: [
      {
        targetTypeId: 6,
        stateId: 36,
        lastModifiedBy: 4,
        cityId: 87630,
        financialYearId: 5,
        tragetValue_currentYear: 33333,
        yearlyTargetId: 106,
        financialYearName: '2024',
        districtId: 507,
        seasonId: 1,
        isEdit: true,
        seasonName: 'Rabi',
        zoneId: 4,
        gridId: 3604,
        tragetValue_previousYear: null,
        targetTypeName: 'Total Premium Target',
      },
      {
        targetTypeId: 6,
        stateId: 36,
        lastModifiedBy: 4,
        cityId: 87630,
        financialYearId: 5,
        tragetValue_currentYear: 33,
        yearlyTargetId: 1006,
        financialYearName: '2024',
        districtId: 507,
        seasonId: 1,
        isEdit: true,
        seasonName: 'Rabi',
        zoneId: 4,
        gridId: 3605,
        tragetValue_previousYear: null,
        targetTypeName: 'Total Premium Target',
      },
    ],
    minTargetCount: 0,
  },
  yearOptions: [
    {
      value: 3,
      label: '2022',
    },
    {
      value: 4,
      label: '2023',
    },
    {
      value: 5,
      label: '2024',
    },
  ],
};
export const trackLocationMockData = {
  roleOption: [
    {
      label: 'CEO',
      value: 1,
    },
    {
      value: 2,
      label: 'BOD',
    },
    {
      label: 'CGO',
      value: 3,
    },
    {
      value: 4,
      label: 'Zonal Head',
    },
    {
      label: 'State Head',
      value: 5,
    },
    {
      value: 6,
      label: 'POSP - Manager',
    },
    {
      value: 7,
      label: 'POSP',
    },
    {
      label: 'VP-Sales',
      value: 8,
    },
  ],
  allRoleOptions: [
    {
      label: 'CEO',
      value: 1,
    },
    {
      value: 2,
      label: 'BOD',
    },
    {
      label: 'CGO',
      value: 3,
    },
    {
      value: 4,
      label: 'Zonal Head',
    },
    {
      label: 'State Head',
      value: 5,
    },
    {
      value: 6,
      label: 'POSP - Manager',
    },
    {
      value: 7,
      label: 'POSP',
    },
    {
      label: 'VP-Sales',
      value: 8,
    },
  ],
  statusCount: {
    totalUsers: 0,
    userCount: 0,
  },
  locationListError: null,
  lastLocationList: [
    {
      employeetype: 1,
      locationName: 'Madhapur',
      roleid: 7,
      rolename: 'POSP',
      latitude: '17.4322271',
      photo:
        'https://sa4fieldassistdev.blob.core.windows.net/fa-datablobs/300_Screenshot_2024-07-02-18-20-29-301_app.iagri.jpg?sv=2022-11-02&ss=bfqt&srt=sco&sp=rwdlacupiytfx&se=2024-10-31T13:23:55Z&st=2024-05-03T05:23:55Z&spr=https&sig=eDq4KoQhpGr3h5t1OSPTIAmUxSFMhu87X7SjJ0tsJLg%3D',
      employeeuniqueid: 'POSP-4-36-000012',
      locationreceivedat: '2024-07-03T10:21:11.278+00:00',
      candidateuniqueid: 'CD-4-36-2407-000300',
      employeeid: 300,
      employeename: 'Text user',
      longitude: '78.3818042',
    },
  ],
  trackHistoryList: [
    {
      employeeTrackingHistoryId: 1197,
      locationName: 'Madhapur',
      referenceType: null,
      referencePkId: null,
      referenceLink: null,
      referenceId: null,
      employeeId: 59,
      longitude: '78.38120637447567',
      locationReceivedAt: '2024-07-08T06:49:37.568+00:00',
      statusId: null,
      referenceModuleName: 'Logged',
      statusName: null,
      referenceModuleId: null,
      latitude: '17.43238780172037',
    },
  ],
};
export const dashboardMockData = {
  selectedMenu: 'home',
  isOpenSideMenu: true,
  isMobile: false,
  listOrView: LIST_VIEW_ITEM.LIST_ITEMS,
};
export const onboardingMockData = {
  updateKYCDocumentStatus: API_STATUS.SUCCEEDED,
  onboardingData: {
    responseInformation: {
      responseCode: '0',
      responseMessage: 'Success',
    },
    result: [
      {
        candidateId: 219,
        candidateUniqueId: 'CD-4-36-2406-000219',
        employeeUniqueId: null,
        firstName: 'MSravya',
        lastName: 'Madhuri',
        gender: 'Female',
        address: '202,Pawan nivas',
        location: 76077,
        locationName: null,
        cityName: null,
        city: 518,
        state: 36,
        zone: 4,
        stateName: null,
        pincode: 500047,
        maritalStatus: 'Married',
        photo:
          'https://sa4fieldassistdev.blob.core.windows.net/fa-datablobs/219_images.jpeg?sv=2022-11-02&ss=bfqt&srt=sco&sp=rwdlacupiytfx&se=2024-10-31T13:23:55Z&st=2024-05-03T05:23:55Z&spr=https&sig=eDq4KoQhpGr3h5t1OSPTIAmUxSFMhu87X7SjJ0tsJLg%3D',
        mobileNumber: 8309949584,
        isMobileVerified: true,
        emailId: 'madhuri@mailinator.com',
        isEmailVerified: false,
        roleId: 7,
        employeeType: null,
        roleName: 'POSP',
        userActivationStatus: 1,
        userActivationStatusName: 'Pending',
        kycStatus: 1,
        kycStatusName: 'Yet to upload',
        trainingStatus: false,
        testStatus: false,
        approvedBy: null,
        approvedByName: null,
        approvedOn: null,
        isDeleted: false,
        createdOn: '2024-06-09T04:49:33.634838',
        lastModifiedOn: '2024-06-16T14:08:28.173856',
        reportingManagerId: null,
        reportingManagerName: 'Sharath Chandra',
        reportingManagerNumber: 6666666664,
        dob: '1996-06-09',
      },
      {
        candidateId: 218,
        candidateUniqueId: 'CD-4-36-2406-000218',
        employeeUniqueId: null,
        firstName: 'tets',
        lastName: 'register',
        gender: 'Male',
        address: 'addd',
        location: 76012,
        locationName: null,
        cityName: null,
        city: 518,
        state: 36,
        zone: 4,
        stateName: null,
        pincode: 500018,
        maritalStatus: 'Unmarried',
        photo:
          'https://sa4fieldassistdev.blob.core.windows.net/fa-datablobs/218_images%20%281%29.jpeg?sv=2022-11-02&ss=bfqt&srt=sco&sp=rwdlacupiytfx&se=2024-10-31T13:23:55Z&st=2024-05-03T05:23:55Z&spr=https&sig=eDq4KoQhpGr3h5t1OSPTIAmUxSFMhu87X7SjJ0tsJLg%3D',
        mobileNumber: 8309949567,
        isMobileVerified: true,
        emailId: 'test@register.com',
        isEmailVerified: false,
        roleId: 7,
        employeeType: null,
        roleName: 'POSP',
        userActivationStatus: 1,
        userActivationStatusName: 'Pending',
        kycStatus: 1,
        kycStatusName: 'Yet to upload',
        trainingStatus: false,
        testStatus: false,
        approvedBy: null,
        approvedByName: null,
        approvedOn: null,
        isDeleted: false,
        createdOn: '2024-06-09T04:43:01.951811',
        lastModifiedOn: '2024-06-09T06:29:22.964256',
        reportingManagerId: null,
        reportingManagerName: 'Sharath Chandra',
        reportingManagerNumber: 6666666664,
        dob: '1978-06-09',
      },
    ],
    pagination: {
      currentPage: 1,
      pageSize: 20,
      totalPages: 1,
      totalItems: 12,
      fromItem: 1,
      toItem: 12,
    },
  },
};
export const employeeDataMockData: EmployeeDataInitialState = {
  employeeList: [
    {
      pincode: 500047,
      lastName: 'Madhuri',
      city: 87597,
      mobileNumber: 6677788888,
      roles: 'POSP',
      photo:
        'https://sa4fieldassistdev.blob.core.windows.net/fa-datablobs/62?sv=2022-11-02&ss=bfqt&srt=sco&sp=rwdlacupiytfx&se=2024-10-31T13:23:55Z&st=2024-05-03T05:23:55Z&spr=https&sig=eDq4KoQhpGr3h5t1OSPTIAmUxSFMhu87X7SjJ0tsJLg%3D',
      emailId: 'sravya@gmail.com',
      reportingManagerName: '',
      reportingManagerId: 1,
      employeeStatus: 'Active',
      candidateUniqueId: 'CD-36-36-2404-000062',
      firstName: 'Sravya',
      zone: 4,
      district: 700,
      employeeUniqueId: 'POSP-36-36-000009',
      reportingManagerNumber: '',
      state: 36,
      candidateId: 62,
    },
  ],
  pagination: {
    currentPage: 1,
    pageSize: 20,
    totalPages: 1,
    totalItems: 1,
    fromItem: 1,
    toItem: 1,
  },
  employeeDetails: {
    reportingManagerDetails: {
      candidateUniqueId: 'CAD0044',
      employeeUniqueId: 'EMP32422',
      roleName: 'CEO',
      fullName: 'Test Manager',
      photo: 'https://kshema.com/rm.jpg',
      candidateId: 234,
    },
    allocatedGrids: [
      {
        revokedon: null,
        candidateid: 62,
        assignedby: 1,
        approvedbyname: ' ',
        assignedon: '2024-04-17T09:06:05.052+00:00',
        revokedby: 0,
        revokedbyname: ' ',
        employeegridmappingid: 36,
        gridid: 3830,
        assignedbyname: '',
      },
      {
        revokedon: null,
        candidateid: 62,
        assignedby: 1,
        approvedbyname: ' ',
        revokedby: 0,
        revokedbyname: ' ',
        employeegridmappingid: 37,
        assignedon: '2024-04-17T09:06:54.022+00:00',
        gridid: 3717,
        assignedbyname: '',
      },
    ],
    reportingDetails: {
      pincode: 500047,
      districtName: 'Medchal Malkajgiri',
      city: 395025,
      employeeStatus: 39,
      employeeStatusName: 'Active',
      employeeType: 1,
      cityName: 'Malkajgiri-Hyderabad',
      zone: 1,
      stateName: 'Telangana',
      district: 27,
      state: 3,
      employeeTypeName: 'EXTERNAL',
      zoneName: 'South Zone',
      role: 0,
    },
    personalDetails: {
      lastName: 'Madhuri',
      kycStatus: 3,
      gender: 'Female',
      city: 395025,
      mobileNumber: 6677788888,
      trainingStatus: true,
      approvedBy: 1,
      emailId: 'sravya@gmail.com',
      createdOn: '2024-04-17T08:44:53.390+00:00',
      isEmailVerified: false,
      approvedOn: '2024-04-17T08:53:49.254+00:00',
      candidateUniqueId: 'CD-36-36-2404-000062',
      cityName: 'Malkajgiri-Hyderabad',
      zone: 1,
      stateName: 'Punjab',
      testStatus: true,
      approvedByName: ' ',
      state: 3,
      zoneName: 'North Zone',
      pincode: 500047,
      userActivationStatusName: 'Active',
      address: 'Plot 202, Pawan Nivas',
      districtName: 'Medchal Malkajgiri',
      photo:
        'https://sa4fieldassistdev.blob.core.windows.net/fa-datablobs/62?sv=2022-11-02&ss=bfqt&srt=sco&sp=rwdlacupiytfx&se=2024-10-31T13:23:55Z&st=2024-05-03T05:23:55Z&spr=https&sig=eDq4KoQhpGr3h5t1OSPTIAmUxSFMhu87X7SjJ0tsJLg%3D',
      userActivationStatus: 3,
      lastModifiedOn: '2024-04-17T09:02:59.028+00:00',
      firstName: 'Sravya',
      kycStatusName: 'Active',
      employeeUniqueId: 'POSP-36-36-000009',
      district: 27,
      isMobileVerified: true,
      candidateId: 62,
      maritalStatus: 'Married',
      fullName: '',
      fullname: '',
      approvedbyname: null,
      maritalstatus: '',
      approvedon: null,
      createdon: '',
      emailid: '',
      statusname: '',
      approvedby: null,
      ismobileverified: false,
      isdeleted: false,
      teststatus: false,
      trainingstatus: false,
      isemailverified: false,
      useractivationstatus: 0,
      lastmodifiedon: '',
      candidateid: '',
      employeeId: '',
      candidateuniqueid: '',
      firstname: '',
      lastname: '',
      location: 0,
      locationname: '',
      cityname: '',
      statename: '',
      mobilenumber: 0,
      roleId: 0,
      roleid: 0,
      roleName: '',
      employeeuniqueid: null,
      isDeleted: false,
      reportingManagerId: 0,
      reportingManagerName: '',
      reportingManagerNumber: 0,
      reportingmanagerid: '',
      reportingmanagername: '',
      reportingmanagernumber: '',
      dob: null,
      kycstatus: 0,
      reportingZones: [],
      reportingStates: [],
      assignedgrids: '',
    },
    campaignDetails: [
      {
        campaignName: 'Search Engine',
        campaignId: 1,
        description_a: null,
        description_b: null,
        employeeCampaignMappingId: 187,
        campaignid: 0,
        employeecampaignmappingid: 0,
        campaignname: null,
        descriptona: null,
        descriptionb: null,
      },
      {
        campaignId: 2,
        campaignName: 'Social Media',
        description_a: null,
        employeeCampaignMappingId: 188,
        description_b: null,
        campaignid: 0,
        employeecampaignmappingid: 0,
        campaignname: null,
        descriptona: null,
        descriptionb: null,
      },
      {
        campaignId: 3,
        employeeCampaignMappingId: 189,
        description_a: null,
        description_b: null,
        campaignName: 'TV',
        campaignid: 0,
        employeecampaignmappingid: 0,
        campaignname: null,
        descriptona: null,
        descriptionb: null,
      },
      {
        description_b: '9659555444',
        description_a: 'Jagan',
        campaignName: 'Referral',
        employeeCampaignMappingId: 190,
        campaignId: 8,
        campaignid: 0,
        employeecampaignmappingid: 0,
        campaignname: null,
        descriptona: null,
        descriptionb: null,
      },
    ],
    roleDetails: [
      {
        roleId: 7,
        roleName: 'POSP',
      },
    ],
    reporteesDetails: [
      {
        candidateId: 456,
        candidateUniqueId: 'CAD34324',
        employeeUniqueId: 'EMP324324',
        fullName: 'Test reportee',
        photo: 'https://www.kshema/image.jpg',
        roleName: 'CGO',
      },
    ],
  },
  employeeStatus: [
    {
      value: 41,
      label: 'In-active',
    },
    {
      value: 39,
      label: 'Active',
    },
    {
      value: 40,
      label: 'Suspended',
    },
  ],
  roleUpdateStatus: {
    response: {
      responseCode: '',
      responseMessage: '',
    },
    status: null,
  },
};
